import Vue from 'vue';

const state = {
  certifications: {},
};

const getters = {
  certifications: state => state.certifications,
  certificationsList: state => Object.keys(state.certifications).map(id => state.certifications[id]),
};

const mutations = {
  setCertifications(state, certifications) {
    for (let certification of certifications) {
      Vue.set(state.certifications, certification.id, certification);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
